const getRecipientKey = (recipientId, recipientType) => `recipient-${recipientType}-${recipientId}`;

const api = {
    getRecipientKey,
};

export default api;
